"use strict";

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");

var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = List;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _useListBox5 = _interopRequireDefault(require("../../useListBox"));

var _handleKeyboardKeys = require("../../helpers/handleKeyboardKeys");

var _OnChangeProvider = require("../../store/OnChangeProvider");

var _PropsProvider = require("../../store/PropsProvider");

var sc = _interopRequireWildcard(require("./List.styles"));

function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { _Object$defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function List(props) {
  var children = props.children,
      height = props.height,
      hasOptions = props.hasOptions;

  var _useListBox = (0, _useListBox5["default"])(),
      _useListBox2 = (0, _slicedToArray2["default"])(_useListBox, 1),
      _useListBox2$ = _useListBox2[0],
      noResultsFound = _useListBox2$.noResultsFound,
      refListBox = _useListBox2$.refListBox;

  var onChangeContext = _react["default"].useContext(_OnChangeProvider.OnChangeContext);

  var _useListBox3 = (0, _useListBox5["default"])(),
      _useListBox4 = (0, _slicedToArray2["default"])(_useListBox3, 2),
      state = _useListBox4[0],
      dispatch = _useListBox4[1];

  var providedProps = _react["default"].useContext(_PropsProvider.PropsContext);

  return /*#__PURE__*/_react["default"].createElement(sc.List, {
    "data-pka-anchor": "styled-list" // TODO: rename to "list-box.list"
    ,
    hasOptions: hasOptions,
    height: height,
    noResultsFound: noResultsFound,
    ref: refListBox,
    onKeyUp: (0, _handleKeyboardKeys.handleKeyUpKeyboardKeys)({
      providedProps: providedProps,
      state: state,
      dispatch: dispatch,
      onChangeContext: onChangeContext
    })
  }, children);
}

List.propTypes = {
  /** Body content of the list. */
  children: _propTypes["default"].node.isRequired,
  hasOptions: _propTypes["default"].bool.isRequired,

  /** Sets the height for the list */
  height: _propTypes["default"].number.isRequired
};
//# sourceMappingURL=List.js.map